<template>
  <!-- D: 포커스시 is-open 클래스 추가 -->
  <!-- D: data-layer-hidden 속성 존재시 단순 검색 케이스로 바뀜 -->

  <!-- PC 영역 -->
  <div
    class="c-filter-search"
    :class="{ 'is-open': isShowHelpLayer }"
    ref="cSearchEl"
    @focusin="() => (isFocusIn = true)"
    v-if="!data.isMobileFlag"
  >
    <h2 class="sr-only">검색 영역</h2>
    <form class="search-form" @submit.prevent="search">
      <label class="sr-only">제품검색</label>
      <input
        type="text"
        id="searchQuery"
        title="검색"
        class="search-input"
        autocomplete="off"
        :placeholder="'제품명/제품코드 입력'"
        :value="keyword"
        @input="handleSearchInput"
      />
      <button type="button" class="search-cancel" @click="onRemoveKewordBtn">
        <i class="c-icon icon-large-x"></i>
        <span class="sr-only">검색어 재입력</span>
      </button>
      <button type="submit" class="search-submit">
        <span class="sr-only">검색</span>
      </button>
    </form>

    <!-- search layer -->
    <div class="search-layer" ref="searchLayerEl">
      <div class="search-layer-inner">
        <!-- D: 입력시 노출, 탭 숨김 -->
        <AutoCustKeywordList
          v-if="isShowAutoKeyword"
          :shwrd="keyword"
          @select="onLatestKeywordSelect"
        />
      </div>
      <button type="button" class="search-layer-close">
        <i class="c-icon icon-small-white-x"></i>
        <span>닫기</span>
      </button>
    </div>
  </div>
  <!-- // PC 영역 -->

  <!-- 모바일 영역 -->
  <div class="c-search only-mo" v-if="data.isMobileFlag">
    <h2 class="sr-only">검색 영역</h2>
    <form class="search-form" @submit.prevent="search">
      <label class="sr-only">제품검색</label>
      <!-- D: MO에서는 input readonly 추가 필요합니다(레이어팝업 오픈하기 위함) -->
      <input
        type="text"
        id="searchQuery"
        title="검색"
        class="search-input"
        autocomplete="off"
        :placeholder="'제품명/제품코드 입력'"
        :value="keyword"
        @input="(event) => (keyword = event.target.value)"
        :readonly="data.isMobileFlag"
      />
      <button type="button" class="search-cancel" @click="onRemoveKewordBtn">
        <i class="c-icon icon-large-x"></i>
        <span class="sr-only">검색어 재입력</span>
      </button>
      <button type="submit" class="search-submit">
        <span class="sr-only">검색</span>
      </button>
    </form>
  </div>
  <!-- // 모바일 영역 -->
</template>

<script setup>
import {
  ref,
  defineEmits,
  defineModel,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  reactive,
} from "vue";
import AutoCustKeywordList from "@/components/paintpro/custCenter/searchCustAutoKeywordList.vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil.js";

const { isMobile } = cmUtil.useDeviceType();

const emits = defineEmits(["keywordChanged"]);
const isFocusIn = ref(false);
const keyword = defineModel("keyword", { required: true });

const cSearchEl = ref(); // 검색필드부분 (top, left, rigth 좌표에 필요)
const searchLayerEl = ref(); // 도우미 확장부분 (bottom 좌표에 필요)

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  isMobileFlag: isMobile.value === "P" ? true : false,
});

onMounted(() => {
  window.addEventListener("click", windowClickEvent);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", windowClickEvent);
});

watch(keyword, () => {
  if (Utils.isNotBlank(keyword.value)) isFocusIn.value = true;
});

const search = () => {
  isFocusIn.value = false;

  // emits("keywordChanged", keyword.value);
};

const isShowAutoKeyword = computed(() => {
  // 자동완성 키워드 표시여부 true: 자동완성 / false: 최근/인기 검색 레이어어
  return Utils.isNotBlank(keyword.value);
});

const isShowHelpLayer = computed(() => {
  return isFocusIn.value;
});

const onRemoveKewordBtn = () => {
  keyword.value = "";
};
const windowClickEvent = (event) => {
  if (
    event.x > cSearchEl.value.getBoundingClientRect().left &&
    event.x < cSearchEl.value.getBoundingClientRect().right &&
    event.y > cSearchEl.value.getBoundingClientRect().top &&
    event.y < searchLayerEl.value.getBoundingClientRect().bottom
  ) {
    isFocusIn.value = true;
  } else {
    isFocusIn.value = false;
  }
};

// 선택한 제품 return 처리
const onLatestKeywordSelect = (selectedKeyword) => {
  isFocusIn.value = false;
  emits("keywordChanged", selectedKeyword);
};

const handleSearchInput = (event) => {
  // 한글 입력 후 마우스 클릭 시 순간적으로 입력값이 없어지고 재 작성되는 현상때문에 setTimeout을 설정함
  setTimeout(() => {
    keyword.value = event.target.value;
  }, 10);
};
</script>
